const cad = new Intl.NumberFormat("fr-CA", {
  style: "currency",
  currency: "CAD",
  minimumFractionDigits: 0,
  maximumFractionDigits: 0,
});
const pct = new Intl.NumberFormat("fr-CA", {
  style: "percent",
  maximumFractionDigits: 0,
});
const decimal = new Intl.NumberFormat("fr-CA", { maximumFractionDigits: 1 });
const int = new Intl.NumberFormat("fr-CA", { maximumFractionDigits: 0 });
const demoFmt = new Intl.DateTimeFormat("fr-CA", {
  timeZone: "America/Toronto",
  day: "numeric",
  month: "short",
  hour: "2-digit",
  minute: "2-digit",
});
const dateTimeFmt = new Intl.DateTimeFormat("fr-CA", {
  timeZone: "America/Toronto",
  dateStyle: "medium",
  timeStyle: "short",
});
const dateFmt = new Intl.DateTimeFormat("fr-CA", {
  timeZone: "America/Toronto",
  dateStyle: "medium",
});
const timeFmt = new Intl.DateTimeFormat("fr-CA", {
  timeZone: "America/Toronto",
  hour: "2-digit",
  minute: "2-digit",
});

export const formatCad = (amount: number | null | undefined): string =>
  cad.format(amount ?? 0);
export const formatPercent = (ratio: number | null | undefined): string =>
  ratio == null ? "—" : pct.format(ratio);
export const formatInt = (n: number | null | undefined): string =>
  int.format(n ?? 0);
export const formatDemoDate = (iso: string): string =>
  demoFmt.format(new Date(iso));
export const formatDateTime = (iso: string): string =>
  dateTimeFmt.format(new Date(iso));
/** Toronto calendar date, e.g. « 3 nov. 2026 ». */
export const formatDate = (iso: string): string =>
  dateFmt.format(new Date(iso));
/** Local (Toronto) time of day, e.g. « 09 h 05 ». GAVION team sessions. */
export const formatTime = (iso: string): string =>
  timeFmt.format(new Date(iso));
export const formatDuration = (seconds: number): string => {
  const s = Math.max(0, Math.round(seconds));
  const h = Math.floor(s / 3600);
  const m = Math.floor((s % 3600) / 60);
  const ss = String(s % 60).padStart(2, "0");
  return h ? `${h}:${String(m).padStart(2, "0")}:${ss}` : `${m}:${ss}`;
};
export const formatDecimal = (n: number): string => decimal.format(n);
